export default {
    'sign-in': 'Iniciar sesión',
    'username': 'Nombre de usuario',
    'password': 'Contraseña',
}